import { END_POINTS } from '@config';
import { api } from '@core/baseApi';

export interface ESignDocument {
  account_id?: string;
  document_id: string;
  document_type: string;
  status: string;
}

export interface GetESignDocumentsResponse {
  documents: ESignDocument[];
}

export interface InitiateESignRequest {
  orgId: string;
  document_id: string;
}

export interface InitiateESignResponse {
  document_id: string;
  status: string;
  message: string;
}

export interface ESignStatusResponse {
  status: string;
}

export interface ESignDetailsResponse {
  document_id: string;
  form_id: string;
  document_type: string;
  provider: string;
  status: string;
  token_id: string;
  provider_document_id: string;
}

const extendedBaseQuery = api.injectEndpoints({
  endpoints: (builder) => ({
    getESignDocuments: builder.query<GetESignDocumentsResponse, string>({
      query: (orgId) => ({
        url: END_POINTS.ORGANIZATION.GET_ESIGN_DOCUMENTS(orgId),
        method: 'GET'
      })
    }),
    initiateESign: builder.mutation<
      InitiateESignResponse,
      InitiateESignRequest
    >({
      query: ({ orgId, document_id }) => ({
        url: END_POINTS.ORGANIZATION.INITIATE_ESIGN(orgId),
        method: 'POST',
        body: { document_id }
      })
    }),
    getESignStatus: builder.query<
      ESignStatusResponse,
      { orgId: string; documentId: string }
    >({
      query: ({ orgId, documentId }) => ({
        url: END_POINTS.ORGANIZATION.GET_ESIGN_STATUS(orgId, documentId),
        method: 'GET'
      })
    }),
    getESignDetails: builder.query<
      ESignDetailsResponse,
      { orgId: string; documentId: string }
    >({
      query: ({ orgId, documentId }) => ({
        url: END_POINTS.ORGANIZATION.GET_ESIGN_DETAILS(orgId, documentId),
        method: 'GET'
      })
    }),
    getESignCompletedStatus: builder.query<
      ESignStatusResponse,
      { orgId: string; documentId: string }
    >({
      query: ({ orgId, documentId }) => ({
        url: END_POINTS.ORGANIZATION.GET_ESIGN_COMPLETED_STATUS(
          orgId,
          documentId
        ),
        method: 'GET'
      })
    })
  })
});

export const {
  useLazyGetESignDocumentsQuery,
  useInitiateESignMutation,
  useLazyGetESignStatusQuery,
  useLazyGetESignDetailsQuery,
  useLazyGetESignCompletedStatusQuery
} = extendedBaseQuery;
